import script from "./NowPlaying.vue?vue&type=script&setup=true&lang=ts"
export * from "./NowPlaying.vue?vue&type=script&setup=true&lang=ts"

import "./NowPlaying.vue?vue&type=style&index=0&id=07413c0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07413c0b"]])

export default __exports__